export default __webpack_public_path__ + "static/media/SAICE-Connect.f4116ab8.png";